const state = {
	data: {
		install: {
			granted: false,
			prompt: false,
		},
		notifications: {
			granted: false,
			prompt: false,
			denied: false
		},
		location: {
			granted: false,
			prompt: false,
			denied: false
		}
	}
}

const getters = {
	GET_NOTIFICATIONS : state => {
		return state.data.notifications
	},
	GET_NOTIFICATIONS_ALLOW : state => {
		return state.data.notifications.granted === true
	},
	GET_LOCATIONS : state => {
		return state.data.location
	},
	GET_LOCATIONS_ALLOW : state => {
		return state.data.location.granted === true
	},
	GET_INSTALL : state => {
		return state.data.install
	},
	GET_INSTALL_ALLOW : state => {
		return state.data.install.granted === true
	}
}

const mutations = {
	PUT_STATE_NOTIFICATIONS : (state, notifications) => {
		state.data.notifications = Object.assign({}, state.data.notifications, notifications)
	},
	PUT_STATE_LOCATION : (state, location) => {
		state.data.location = Object.assign({}, state.data.location, location)
	},
	PUT_STATE_INSTALL : (state, install) => {
		state.data.install = Object.assign({}, state.data.install, install)
	}
}

const actions = {
	PUT_STATE_NOTIFICATIONS : async (context, notifications) => {
		context.commit('PUT_STATE_NOTIFICATIONS', notifications)
	},
	PUT_STATE_LOCATION : async (context, location) => {
		context.commit('PUT_STATE_LOCATION', location)
	},
	PUT_STATE_INSTALL : async (context, install) => {
		context.commit('PUT_STATE_INSTALL', install)
	}
}

export default {
	state, getters, mutations, actions
}



// WEBPACK FOOTER //
// ./src/store/modules/permits.js